import { useState, useEffect } from "react";

const TARGET_WIDTH = 1920;
const TARGET_HEIGHT = 1080;

export function useScreenScale() {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      const widthScale = window.innerWidth / TARGET_WIDTH;
      const heightScale = window.innerHeight / TARGET_HEIGHT;
      setScale(Math.min(widthScale, heightScale));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return scale;
}
